<div class="notification" [ngClass]="typeCSSClass">
  <span class="notification__bubble">
    <i [className]="pictogram"></i>
  </span>
  <p class="notification__message">{{ message | translate }}</p>
  <i class="notification__close itvf-close" [ariaLabel]="'CLOSE' | translate" (click)="close()"></i>
</div>
